/**
* Home Laptop Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Home Laptop Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'home-laptop-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.home-laptop-banner' ).each( function( key, val ) {
        const openingAnimation = lottie.loadAnimation( {
          container: $( this ).find( '.opening-laptop-animation' )[0],
          renderer: 'svg',
          name: 'opening-laptop-animation',
          loop: false,
          autoplay: false,
          path: $( this ).find( '.opening-laptop-animation' ).attr( 'data-url' ),
        } );

        let navHeight = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).outerHeight();
        }

        const wysiwyg = $( this ).find( '.wysiwyg' )[0];
        const person1 = $( this ).find( '.member-card--1' )[0];
        const person2 = $( this ).find( '.member-card--2' )[0];
        const timeObj = {currentFrame: 0};
        const objDuration = 1;
        // const endString = ( obj.speed === 'slow' ) ? '+=2000' : ( obj.speed === 'medium' ) ? '+=1000' : ( obj.speed === undefined ) ? '+=1250' : '+=500';
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( this ).find( '.inner-area' )[0],
            start: 'top ' + ( navHeight + 80 ) + 'px',
            end: 'bottom top',
            pin: $( this ).find( '.inner-area' )[0],
            scrub: 0,
            // markers: true,
            onRefresh: ( self ) => {
              console.log( 'eh' );
              if ( objDuration ) {
                gsap.to( timeObj, {
                  duration: objDuration,
                  currentFrame: ( Math.floor( self.progress * openingAnimation.totalFrames ) ),
                  onUpdate: () => {
                    openingAnimation.goToAndStop( timeObj.currentFrame, true );
                  },
                  ease: 'expo',
                } );
              } else {
                openingAnimation.goToAndStop( self.progress * openingAnimation.totalFrames, true );
              }
            },
            onUpdate: ( self ) => {
              console.log( Math.floor( self.progress * openingAnimation.totalFrames ) );
              if ( objDuration ) {
                gsap.to( timeObj, {
                  duration: objDuration,
                  currentFrame: ( Math.floor( self.progress * openingAnimation.totalFrames ) ),
                  onUpdate: () => {
                    openingAnimation.goToAndStop( timeObj.currentFrame, true );
                  },
                  ease: 'expo',
                } );
              } else {
                openingAnimation.goToAndStop( self.progress * openingAnimation.totalFrames, true );
              }
            },
          },
        } );
        tl.to( wysiwyg, {'y': '-125%', 'opacity': 0, 'ease': 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'home-laptop-banner', COMPONENT );
} )( app );
